import React, { useState, useEffect } from "react";
import classes from "../style/Style.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "../libs/axiosConfig";
import { ToastContainer } from "react-toastify";
import Toast from "../Components/ToastMsg/Toast";
import {
  ROUTE_KYC_NOT_DONE,
  ROUTE_KYC_PROCESS,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_CUSTOMER_SUPPORT_SCREEN,
} from "../Routes";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { selectPhoneNumber } from "../Store/MobileSlice";
import { selectPanNumber, setPanNumber } from "../Store/panNumberSlice";
// import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import { selectStateCode, setStateCode } from "../Store/StateCodeSlice";
import LogoutModal from "../Components/LogoutModal";
import statesList from "../Components/StateList";

const PanNumber = () => {
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  // const panNumber = useSelector(selectPanNumber);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const [isLoading, setIsLoading] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);
  // const StateCode = useSelector(selectStateCode);
  const [formErrors, setFormErrors] = useState({});
  const [apiPan, setApiPan] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showClearButton, setShowClearButton] = useState(false);
  const [userInputPan, setUserInputPan] = useState("");
  // const refreshToken = useSelector(selectRefreshToken);
  // const StateCode = useSelector(selectStateCode);

  let APICallOnce = false;
  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  const fetchDexterrCustomerBasicQuestions = async () => {
    try {
      const apiUrl =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };
      const requestBody = {
        dexterrCustomerBasicQuestions: {
          mobile_no: phoneNumber,
          request_type: "get",
          country_code: "+91",
        },
      };

      const response = await axios.post(apiUrl, requestBody, { headers });

      if (response.status === 200) {
        console.log("pan screen fetchDexterrCustomerBasicQuestions");
        if (response.status === 200) {
          const { pan } = response.data.data.pan_number;
          setApiPan(pan);
          setUserInputPan(pan);
          setShowClearButton(!pan);
        } else {
          Toast.error(response.data.message + " " + response.data.errorMessage);
        }
      } else {
        Toast.error(response.data.message + " " + response.data.errorMessage);
      }
    } catch (error) {
      // Toast.error("Invalid pan please try again..");
    }
  };

  useEffect(() => {
    if (!APICallOnce) {
      APICallOnce = true;
      fetchDexterrCustomerBasicQuestions();
    }
  }, []);

  const handleInputChange = (e) => {
    const inputValue = e.target.value.toUpperCase();
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(inputValue)) {
      setFormErrors({ pan: "Enter a valid PAN Number" });
    } else {
      setFormErrors({});
    }
    dispatch(setPanNumber(inputValue));
    setUserInputPan(inputValue);
  };

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const HandleSubmit = async () => {
    if (!apiPan && !userInputPan) {
      toast.error("Please enter your PAN number");
      return;
    }

    const panFormatRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panFormatRegex.test(userInputPan)) {
      toast.error("Enter a valid PAN Number");
      return;
    }
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };
      setApiCallsInProgress(apiCallsInProgress + 1);

      if (apiPan) {
        console.log("from here 1");
        const iciciApiUrl =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        try {
          const iciciResponse = await axios.post(
            iciciApiUrl,
            {
              dexterrCustomerBasicQuestions: {
                mobile_no: phoneNumber,
                request_type: "post",
                country_code: "+91",
                pan: panNumber,
              },
            },
            { headers }
          );
          if (

            iciciResponse.statusCode === 200
          ) {
            // setApiCallsInProgress(apiCallsInProgress - 1);

            console.log(iciciResponse.data.status);
            console.log(iciciResponse.statusCode);
            const { status } = iciciResponse.data.data.response;
            function convertKeysToLowerCase(obj) {
              const convertedObject = {};
              for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                  const convertedKey = key.toLowerCase();
                  convertedObject[convertedKey] = obj[key];
                }
              }
              return convertedObject;
            }

            const response = convertKeysToLowerCase(
              iciciResponse.data.data.response
            );
            // console.log(response);
            // console.log(response.f_pan_name);
            // console.log(response.description);

            if (status === "1" && response.f_pan_status === "ok") {
              Navigate(ROUTE_KYC_PROCESS, {
                state: { fullName: response.f_pan_name },
              });
            } else if (status === "4" && response.f_pan_status === "pending") {
              Navigate(ROUTE_KYC_NOT_DONE);
            } else if (status === "0" && response.f_pan_status === "invalid") {
              toast.error(response.pan_block_msg);

              Navigate(ROUTE_KYC_NOT_DONE);
            } else {
              // console.log(iciciResponse.data.data.code);
              if (response.description !== "") {
                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: { reason: response.description },
                });
              } else {
                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: {
                    reason:
                      response.data.message + " " + response.data.errorMessage,
                  },
                });
                // Toast.error(
                //   response.data.message + " " + response.data.errorMessage
                // );
              }
            }

            // else {
            //   // Toast.error(
            //   //   iciciResponse.data.message +
            //   //     " " +
            //   //     iciciResponse.data.errorMessage
            //   // );
            //   const apiUrl =

            //   axios
            //     .get(apiUrl, {
            //       headers: {
            //         "Content-Type": "application/json",
            //         Authorization: `Bearer ${storedToken}`,
            //       },
            //     })
            //     .then((Basicresponse) => {
            //       if (
            //         Basicresponse.data.statusCode === 200 &&
            //         Basicresponse.data.status === true
            //       ) {
            //         if (
            //           Basicresponse.data.data.ambrelaKycStatus !== "Successful" ||
            //           Basicresponse.data.data.externalKycStatus === "Successful"
            //         ) {
            //           Navigate(ROUTE_KYC_PROCESS);
            //         }
            //         else if (
            //           Basicresponse.data.data.ambrelaKycStatus === "Successful" ||
            //           Basicresponse.data.data.externalKycStatus !== "Successful"
            //         )
            //         {
            //           Navigate(ROUTE_KYC_PROCESS);
            //         }
            //       } else {
            //         Navigate(ROUTE_KYC_NOT_DONE);
            //         Toast.error("Error During OTP Verification");
            //       }
            //     });
            //   // toast.error(
            //   //   iciciResponse.data.message || iciciResponse.data.errorMessage
            //   // );

            //   setFormErrors({
            //     ...formErrors,
            //     // pan: "Error during PAN validation",
            //   });

            // }
          } else {
            const apiUrl =
              "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

            const requestBody = {
              dexterrCustomerBasicQuestions: {
                mobile_no: phoneNumber,
                country_code: "+91",
                request_type: "get",
              },
            };

            axios
              .post(apiUrl, requestBody, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${storedToken}`,
                },
              })
              .then((Basicresponse) => {
                console.log(Basicresponse.data);
                console.log(Basicresponse.data.status);
                if (
                  Basicresponse.data.statusCode === 200 &&
                  Basicresponse.data.status === true
                ) {
                  setApiCallsInProgress(apiCallsInProgress - 1);

                  if (
                    Basicresponse.data.data.ambrelaKycStatus !== "Successful" ||
                    Basicresponse.data.data.externalKycStatus === "Successful"
                  ) {
                    Navigate(ROUTE_KYC_PROCESS);
                  } else if (
                    Basicresponse.data.data.ambrelaKycStatus === "Successful" ||
                    Basicresponse.data.data.externalKycStatus !== "Successful"
                  ) {
                    Navigate(ROUTE_KYC_PROCESS);
                  }
                } else {
                  setApiCallsInProgress(apiCallsInProgress - 1);

                  Navigate(ROUTE_KYC_NOT_DONE);
                  Toast.error("Error During OTP Verification");
                }
              });
            // toast.error(
            //   iciciResponse.data.message || iciciResponse.data.errorMessage
            // );

            setFormErrors({
              ...formErrors,
              // pan: "Error during PAN validation",
            });
          }
        } catch (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.Response &&
            error.response.data.Response.pan_block_msg
          ) {
            toast.error(error.response.data.Response.message);

            // console.log(error.response.data.Response,);
          } else {
            // Toast.error("Invalid pan please try again..");
          }
          setFormErrors({
            ...formErrors,
            // pan: "Error during PAN validation",
          });
        }
      } else {
        console.log("from here");
        const apiUrl =
          " https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        const requestBody = {
          validateCustomerPan: userInputPan,
        };

        console.log(userInputPan, "pan is there");
        try {
          const response = await axios.post(apiUrl, requestBody, { headers });

          const address = response.data?.data?.data?.address || {};
          const state = address.state || "";
          const zip = address.zip || "";
          const country = address.country || "";
          const line1 = address.line1 || "";
          const line2 = address.line2 || "";
          const full = address.full || "";
          const city = address.city || "";
          const fullname = response.data?.data?.data?.fullname || "";
          const gender = response.data?.data?.data?.gender || "";
        
          console.log(state, 'state');
          console.log(zip, 'zip');
          console.log(country, 'country');
          console.log(line1, 'line1');
          console.log(line2, 'line2');
          console.log(full, 'full');
          console.log(city, 'city');
          console.log(fullname, 'fullname');
          console.log(gender, 'gender');
        
          const matchedState = statesList.find(
            (stateItem) => stateItem.name.toLowerCase() === state.toLowerCase()
          ) || { code: "" };
          
          console.log(matchedState.code, 'matched state code');
          dispatch(setStateCode(state));
        
          const title = gender === "M" ? "Mr." : gender === "F" ? "Ms." : "";
        // Make a POST request to the first API endpoint
        const firstapi =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        const postrequestBody = {
          CustomerKycDetails: {
            request_type: "post",
            mobileNumber: phoneNumber,
            country_code: "+91",
            pan: panNumber || userInputPan || apiPan,
            nseStateCode: matchedState.code,
            zip,
            country,
            addr1: line1,
            addr2: line2,
            inv_name: fullname,
            city,
            gender,
            fullAddress: full,
            nseStateDescription: state,
            title,
          },
        };

        const postresponse = await axios.post(firstapi, postrequestBody, {
          headers,
        });
        
        // if (postresponse.data.statusCode === 200) {
        //   const postsecondapi =
        //     "https://partnerapp.ambrela.money/api/AddCustomerKycDetails";
        //   const postsecondRequestBody = {
        //     // nseStateCode: matchedState.code,
        //     // nseStateDescription: responseState,
        //     title: title,
        //   };

        //   const postsecondResponse = await axios.post(
        //     postsecondapi,
        //     postsecondRequestBody,
        //     {
        //       headers,
        //     }
        //   );
        //   console.log("Second API Response:", postsecondResponse.data);
        // }

        if (response.data.statusCode === 200 && response.data.status === true) {

          // Call icicipruamcPanCheckKyc API only when submit is successful
          const iciciApiUrl =
            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
          try {
            const iciciResponse = await axios.post(
              iciciApiUrl,
              {
                dexterrCustomerBasicQuestions: {
                  mobile_no: phoneNumber,
                  request_type: "post",
                  country_code: "+91",
                  pan: panNumber,
                },
              },
              { headers }
            );
            if (
              iciciResponse.data.status === true &&
              iciciResponse.statusCode === 200
            ) {
              const { status } = iciciResponse.data.data.response;
              function convertKeysToLowerCase(obj) {
                const convertedObject = {};
                for (let key in obj) {
                  if (obj.hasOwnProperty(key)) {
                    const convertedKey = key.toLowerCase();
                    convertedObject[convertedKey] = obj[key];
                  }
                }
                return convertedObject;
              }
              const response = convertKeysToLowerCase(
                iciciResponse.data.data.response
              );
              if (status === "1" && response.f_pan_status === "ok") {
                Navigate(ROUTE_KYC_PROCESS, {
                  state: { fullName: response.f_pan_name },
                });
              } else if (
                status === "4" &&
                response.f_pan_status === "pending"
              ) {
                Navigate(ROUTE_KYC_NOT_DONE);
              } else if (
                status === "0" &&
                response.f_pan_status === "invalid"
              ) {
                Navigate(ROUTE_KYC_NOT_DONE);
              } else {
                // console.log(iciciResponse.data.data.code);
                if (response.description !== "") {
                  Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                    state: { reason: response.description },
                  });
                } else {
                  Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                    state: {
                      reason:
                        response.data.message +
                        " " +
                        response.data.errorMessage,
                    },
                  });
                  // Toast.error(
                  //   response.data.message + " " + response.data.errorMessage
                  // );
                }
              }
            } else {
              const apiUrl =
                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
              const requestBody = {
                dexterrCustomerBasicQuestions: {
                  mobile_no: phoneNumber,
                  request_type: "get",
                  country_code: "+91",
                },
              };

              axios
                .post(apiUrl, requestBody, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${storedToken}`,
                  },
                })
                .then((Basicresponse) => {
                  if (
                    Basicresponse.data.statusCode === 200 &&
                    Basicresponse.data.status === true
                  ) {
                    setApiCallsInProgress(apiCallsInProgress - 1);

                    if (
                      Basicresponse.data.data.ambrelaKycStatus !==
                      "Successful" ||
                      Basicresponse.data.data.externalKycStatus === "Successful"
                    ) {
                      Navigate(ROUTE_KYC_PROCESS);
                    } else if (
                      Basicresponse.data.data.ambrelaKycStatus ===
                      "Successful" ||
                      Basicresponse.data.data.externalKycStatus !== "Successful"
                    ) {
                      Navigate(ROUTE_KYC_PROCESS);
                    }
                  } else {
                    setApiCallsInProgress(apiCallsInProgress - 1);

                    Navigate(ROUTE_KYC_NOT_DONE);
                    Toast.error("Error During OTP Verification");
                  }
                });
              // toast.error(
              //   iciciResponse.data.message || iciciResponse.data.errorMessage
              // );

              setFormErrors({
                ...formErrors,
                // pan: "Error during PAN validation",
              });
            }
          } catch (error) {
            // console.error("", error);
            // Toast.error("Invalid PAN");
            setFormErrors({
              ...formErrors,
              // pan: "Error during PAN validation",
            });
          }
        } else if (response.data.statusCode === 400 && response.data.status === "False" && response.data.errorMessage) {
          // console.log(response.data.message);
          setApiCallsInProgress(apiCallsInProgress - 1);

          Toast.error(response.data.errorMessage);
        }

        else if (
          response.data.statusCode === 200 &&
          response.data.status === false
        ) {
          setApiCallsInProgress(apiCallsInProgress - 1);

          Toast.error(response.data.message + " " + response.data.errorMessage);
        }
        
      } catch (error) {
        console.error("Error during API call:", error);
      }
      }

    
    } catch (error) {
      // console.error("Invalid PAN", error.response.data);
      // toast.error("Invalid PAN");
      Toast.error(
        error.response.data.errorMessage + " " + error.response.data.message ||
        "Error"
      );
      setApiCallsInProgress(apiCallsInProgress + 1);

    }
  };

  return (
    <div className="EnteringPan_Main_Container">
      <div className="psHeader">
        <ArrowBackIosIcon className="psBack_btn" onClick={HandleBack} />

        {/* <div className={classes.Dexter_Explainer_Container}>
          <img alt="" src={DexterCall} />
          <span className={classes.Dexter_Call_text}>Dexterr Explains</span>
        </div> */}
      </div>
      <div className="PsVerify_Otp_Div_Container">
        <p className="PsInput_Heading_text">What’s your PAN Number?</p>
        <span className="PsInput_Sub_heading">
          By sharing your PAN number, you help us comply with KYC regulations
          and protect your financial information.
        </span>
        <div className="PsInput_Filed_Box">
          <span className="PsEnter_mobile_text">
            Enter your PAN Number
          </span>
          <div className="PsInput_Inner_Container">
            {apiPan ? (
              <input
                className={classes.Input_Filed}
                value={apiPan}
                placeholder="eg: ABCTY1234D"
                disabled
              />
            ) : (
              <input
                className={classes.Input_Filed}
                value={userInputPan}
                onChange={handleInputChange}
                placeholder="eg: ABCTY1234D"
                maxLength={10}
              />
            )}

            {showClearButton && (
              <button
                className="PsCross_button"
                onClick={() => setUserInputPan("")}
              ></button>
            )}
          </div>
        </div>

        {formErrors.pan && (
          <span className={classes.Error_Message}>{formErrors.pan}</span>
        )}
        <p className="PsNoteText">
          Note: PAN is mandatory as per SEBI regulations for mutual fund
          investments. Also, PAN will be used for your KYC and all your future
          investments.
          <br />
          <br />
          PAN cannot be changed later. By submitting PAN, you consent to Must
          Desrrupt Technologies Pvt Ltd to processing your information for
          performing KYC and creation of your account for enabling investments
          in mutual funds.
          <br />
          <br />
          Must Desrrupt Technologies Pvt Ltd{" "}
          <a
            href="https://www.ambrela.money/terms-of-service-and-grievance-policy"
            target="_blank"
            style={{ color: "#696969" }}
            rel="noreferrer"
          >
            Terms & Conditions
          </a>{" "}
          and{" "}
          <a
            href="https://www.ambrela.money/privacy-policy"
            target="_blank"
            style={{ color: "#696969" }}
            rel="noreferrer"
          >
            Privacy Policy
          </a>{" "}
          apply.
        </p>
        <button className="PsSubmit_button" onClick={HandleSubmit}>
          {" "}
          Submit{" "}
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      <ToastContainer />
    </div>
  );
};

export default PanNumber;
